import src from "IMAGE";
export default { src, width: 281, height: 46, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAI0lEQVR42mMwNTVNc3Z2bmZhYQlgYGBIAuJIII4D4hwgDgYAWVYEhgE/o0IAAAAASUVORK5CYII="};
